<template>
    <app-content-admin>
        <template slot="header">Add User </template>
        <template slot="button">
            <v-btn style="margin-left: auto" large color="secondary" to="/user">
                Back
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('First Name')"
                                        v-model="form.firstname"
                                        outlined
                                        :rules="[rules.required('First Name')]"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Last Name')"
                                        v-model="form.lastname"
                                        outlined
                                        :rules="[rules.required('Last Name')]"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Email')"
                                        v-model="form.email"
                                        outlined
                                        :rules="[rules.required('Email')]"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Password')"
                                        v-model="form.password"
                                        :append-icon="
                                            showpass ? 'mdi-eye' : 'mdi-eye-off'
                                        "
                                        :rules="[rules.required('Password')]"
                                        :type="showpass ? 'text' : 'password'"
                                        outlined
                                        @click:append="showpass = !showpass"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            color="primary"
                            @click="createUser"
                            class="form-submit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                firstname: null,
                lastname: null,
                email: null,
                password: null,
                id_project: null,
                roles: null,
            },
            showpass: false,
        };
    },

    components: { ActiveLabel },

    created() {
  
    },

    methods: {
        //Create User
        async createUser() {
            let loader = this.$loading.show();
            try {
                let res = await axios.post(`/api/auth/create_user`, this.form);
                if (res.status == 200) {
                    this.$toastr.s("User created successfully");
                    this.$router.push("/user");
                }
            } catch (err) {
              //  this.$toastr.e(err.response.data.message);
            } finally {
                loader.hide();
            }
        },
    },
};
</script>
